import React from "react";

export default function MaintenanceIndex(props) {
  return (
      <div className="w-100 d-flex flex-row justify-content-center mt-5">
          <div className="alert alert-danger py-3 px-4 text-center" style={{'borderRadius':'10px'}}>
            <h3 className="m-0 p-0">Maintenance Mode</h3>
            <p className="m-0 p-0">Please wait until it's done</p>
          </div>
      </div>
  );
}
